// reducers.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiBaseURL } from "./utils";

export function fetch() {
  return new Promise<{ data: string }>((resolve) =>
    setTimeout(() => resolve({ data: "success" }), 500)
  );
}

export const audiences = [
  { id: "blog-readers", name: "Blog Readers" },
  { id: "my-linkedin-feed", name: "My LinkedIn Feed" },
  { id: "college-students", name: "College Students" },
  { id: "high-school-students", name: "High School Students" },
  {
    id: "professionals-in-corporate-settings",
    name: "Professionals in Corporate Settings",
  },
  {
    id: "my-employees",
    name: "My Employees",
  },
  {
    id: "my-supervisors",
    name: "My Supervisors",
  },
  { id: "technical-experts", name: "Technical Experts" },
  { id: "instagram-followers", name: "Instagram Followers" },
  { id: "twitter-followers", name: "Twitter Followers" },
  { id: "tiktok-viewers", name: "TikTok Viewers" },
  { id: "non-profit-donors", name: "Non-Profit Donors" },
  { id: "government-officials", name: "Government Officials" },
  { id: "entrepreneurs-and-startups", name: "Entrepreneurs and Startups" },
  { id: "online-shoppers", name: "Online Shoppers" },
  { id: "parents", name: "Parents" },
  { id: "environmental-advocates", name: "Environmental Advocates" },
  { id: "healthcare-patients", name: "Healthcare Patients" },
  { id: "educators-and-teachers", name: "Educators and Teachers" },
  {
    id: "sci-fi-and-fantasy-enthusiasts",
    name: "Sci-Fi and Fantasy Enthusiasts",
  },
  { id: "diy-hobbyists", name: "DIY Hobbyists" },
  { id: "fitness-enthusiasts", name: "Fitness Enthusiasts" },
];

export const tones = [
  { id: "academic", name: "Academic" },
  { id: "accessible", name: "Accessible" },
  { id: "actionable", name: "Actionable" },
  { id: "adaptable", name: "Adaptable" },
  { id: "adaptive", name: "Adaptive" },
  { id: "adventurous", name: "Adventurous" },
  { id: "affirming", name: "Affirming" },
  { id: "analytical", name: "Analytical" },
  { id: "appreciative", name: "Appreciative" },
  { id: "approachable", name: "Approachable" },
  { id: "articulate", name: "Articulate" },
  { id: "assertive", name: "Assertive" },
  { id: "authentic", name: "Authentic" },
  { id: "authoritative", name: "Authoritative" },
  { id: "balanced", name: "Balanced" },
  { id: "benefit-focused", name: "Benefit-focused" },
  { id: "bold", name: "Bold" },
  { id: "calm", name: "Calm" },
  { id: "cautious", name: "Cautious" },
  { id: "challenging", name: "Challenging" },
  { id: "clarifying", name: "Clarifying" },
  { id: "clear", name: "Clear" },
  { id: "clever", name: "Clever" },
  { id: "collaborative", name: "Collaborative" },
  { id: "community-oriented", name: "Community-oriented" },
  { id: "compassionate", name: "Compassionate" },
  { id: "compelling", name: "Compelling" },
  { id: "comprehensive", name: "Comprehensive" },
  { id: "concise", name: "Concise" },
  { id: "confident", name: "Confident" },
  { id: "constructive", name: "Constructive" },
  { id: "consultative", name: "Consultative" },
  { id: "conversational", name: "Conversational" },
  { id: "courteous", name: "Courteous" },
  { id: "credible", name: "Credible" },
  { id: "curious", name: "Curious" },
  { id: "decisive", name: "Decisive" },
  { id: "descriptive", name: "Descriptive" },
  { id: "detailed", name: "Detailed" },
  { id: "diplomatic", name: "Diplomatic" },
  { id: "direct", name: "Direct" },
  { id: "educational", name: "Educational" },
  { id: "efficient", name: "Efficient" },
  { id: "empathetic", name: "Empathetic" },
  { id: "empowering", name: "Empowering" },
  { id: "encouraging", name: "Encouraging" },
  { id: "energetic", name: "Energetic" },
  { id: "engaging", name: "Engaging" },
  { id: "enthusiastic", name: "Enthusiastic" },
  { id: "exciting", name: "Exciting" },
  { id: "explanatory", name: "Explanatory" },
  { id: "expressive", name: "Expressive" },
  { id: "factual", name: "Factual" },
  { id: "fair", name: "Fair" },
  { id: "festive", name: "Festive" },
  { id: "focused", name: "Focused" },
  { id: "forward-looking", name: "Forward-looking" },
  { id: "friendly", name: "Friendly" },
  { id: "gentle", name: "Gentle" },
  { id: "genuine", name: "Genuine" },
  { id: "grounded", name: "Grounded" },
  { id: "growth-oriented", name: "Growth-oriented" },
  { id: "helpful", name: "Helpful" },
  { id: "holistic", name: "Holistic" },
  { id: "hopeful", name: "Hopeful" },
  { id: "humorous", name: "Humorous" },
  { id: "imaginative", name: "Imaginative" },
  { id: "improvement-focused", name: "Improvement-focused" },
  { id: "inclusive", name: "Inclusive" },
  { id: "innovative", name: "Innovative" },
  { id: "insightful", name: "Insightful" },
  { id: "inspirational", name: "Inspirational" },
  { id: "instructional", name: "Instructional" },
  { id: "instructive", name: "Instructive" },
  { id: "investigative", name: "Investigative" },
  { id: "literary", name: "Literary" },
  { id: "logical", name: "Logical" },
  { id: "methodical", name: "Methodical" },
  { id: "motivational", name: "Motivational" },
  { id: "mysterious", name: "Mysterious" },
  { id: "neutral", name: "Neutral" },
  { id: "non-defensive", name: "Non-defensive" },
  { id: "non-dogmatic", name: "Non-dogmatic" },
  { id: "non-judgmental", name: "Non-judgmental" },
  { id: "nostalgic", name: "Nostalgic" },
  { id: "nuanced", name: "Nuanced" },
  { id: "objective", name: "Objective" },
  { id: "open-minded", name: "Open-minded" },
  { id: "optimistic", name: "Optimistic" },
  { id: "organized", name: "Organized" },
  { id: "passionate", name: "Passionate" },
  { id: "patient", name: "Patient" },
  { id: "personable", name: "Personable" },
  { id: "persuasive", name: "Persuasive" },
  { id: "playful", name: "Playful" },
  { id: "positive", name: "Positive" },
  { id: "practical", name: "Practical" },
  { id: "pragmatic", name: "Pragmatic" },
  { id: "precise", name: "Precise" },
  { id: "principled", name: "Principled" },
  { id: "proactive", name: "Proactive" },
  { id: "professional", name: "Professional" },
  { id: "protective", name: "Protective" },
  { id: "provocative", name: "Provocative" },
  { id: "punchy", name: "Punchy" },
  { id: "purposeful", name: "Purposeful" },
  { id: "realistic", name: "Realistic" },
  { id: "reassuring", name: "Reassuring" },
  { id: "reflective", name: "Reflective" },
  { id: "relevant", name: "Relevant" },
  { id: "resilient", name: "Resilient" },
  { id: "resourceful", name: "Resourceful" },
  { id: "respectful", name: "Respectful" },
  { id: "revealing", name: "Revealing" },
  { id: "sarcastic", name: "Sarcastic" },
  { id: "sensitive", name: "Sensitive" },
  { id: "serious", name: "Serious" },
  { id: "service-oriented", name: "Service-oriented" },
  { id: "shareable", name: "Shareable" },
  { id: "sincere", name: "Sincere" },
  { id: "solution-oriented", name: "Solution-oriented" },
  { id: "specific", name: "Specific" },
  { id: "standards-focused", name: "Standards-focused" },
  { id: "straightforward", name: "Straightforward" },
  { id: "strategic", name: "Strategic" },
  { id: "supportive", name: "Supportive" },
  { id: "systematic", name: "Systematic" },
  { id: "thorough", name: "Thorough" },
  { id: "thought-provoking", name: "Thought-provoking" },
  { id: "thoughtful", name: "Thoughtful" },
  { id: "timely", name: "Timely" },
  { id: "transformational", name: "Transformational" },
  { id: "transparent", name: "Transparent" },
  { id: "understanding", name: "Understanding" },
  { id: "user-focused", name: "User-focused" },
  { id: "user-friendly", name: "User-friendly" },
  { id: "validating", name: "Validating" },
  { id: "value-focused", name: "Value-focused" },
  { id: "warm", name: "Warm" },
  { id: "welcoming", name: "Welcoming" },
  { id: "witty", name: "Witty" },
];

export const styles = [
  { id: "informal", name: "Informal" },
  { id: "formal", name: "Formal" },
  { id: "professional", name: "Professional" },
  { id: "casual", name: "Casual" },
  { id: "creative", name: "Creative" },
  { id: "technical", name: "Technical" },
  { id: "informative", name: "Informative" },
  { id: "structured", name: "Structured" },
  { id: "data-driven", name: "Data-driven" },
  { id: "scholarly", name: "Scholarly" },
  { id: "rigorous", name: "Rigorous" },
];

export const personas = [
  { id: "friendly-blogger", name: "Friendly Blogger" },
  { id: "corporate-executive", name: "Corporate Executive" },
  { id: "tech-savvy-engineer", name: "Tech-Savvy Engineer" },
  { id: "academic-researcher", name: "Academic Researcher" },
  { id: "motivational-coach", name: "Motivational Coach" },
  { id: "social-media-influencer", name: "Social Media Influencer" },
  { id: "creative-storyteller", name: "Creative Storyteller" },
  { id: "data-driven-analyst", name: "Data-Driven Analyst" },
  { id: "health-and-wellness-expert", name: "Health and Wellness Expert" },
  { id: "eco-conscious-advocate", name: "Eco-Conscious Advocate" },
  { id: "parenting-advisor", name: "Parenting Advisor" },
  { id: "adventurous-traveler", name: "Adventurous Traveler" },
  { id: "fiction-author", name: "Fiction Author" },
  { id: "how-to-guide-author", name: "How-To Guide Author" },
  { id: "marketing-specialist", name: "Marketing Specialist" },
  { id: "non-profit-advocate", name: "Non-Profit Advocate" },
  { id: "startup-founder", name: "Startup Founder" },
  { id: "educational-instructor", name: "Educational Instructor" },
  { id: "journalistic-reporter", name: "Journalistic Reporter" },
  {
    id: "customer-service-representative",
    name: "Customer Service Representative",
  },
];

export const models = [
  {
    id: "gpt-4o",
    organization: "OpenAI",
    name: "ChatGPT-4o",
    profileImageURL: "/chatgpt.svg",
    type: "balanced",
  },
  {
    id: "gpt-4.1",
    organization: "OpenAI",
    name: "GPT-4.1",
    profileImageURL: "/chatgpt.svg",
    type: "balanced",
  },
  {
    id: "gpt-4o-mini",
    organization: "OpenAI",
    name: "ChatGPT-4o Mini",
    profileImageURL: "/chatgpt.svg",
    type: "cheap",
  },
  {
    id: "gpt-4.1-mini",
    organization: "OpenAI",
    name: "GPT-4.1 mini",
    profileImageURL: "/chatgpt.svg",
    type: "cheap",
  },
  {
    id: "o1-mini",
    organization: "OpenAI",
    name: "o1-mini",
    profileImageURL: "/chatgpt.svg",
    type: "reasoning",
  },
  {
    id: "o3-mini",
    organization: "OpenAI",
    name: "o3-mini",
    profileImageURL: "/chatgpt.svg",
    type: "reasoning",
  },
  {
    id: "o4-mini",
    organization: "OpenAI",
    name: "o4-mini",
    profileImageURL: "/chatgpt.svg",
    type: "reasoning",
  },
  {
    id: "o1",
    organization: "OpenAI",
    name: "o1",
    profileImageURL: "/chatgpt.svg",
    type: "reasoning",
  },
  {
    id: "o3",
    organization: "OpenAI",
    name: "o3",
    profileImageURL: "/chatgpt.svg",
    type: "reasoning",
  },
  {
    id: "claude-3-5-sonnet-latest",
    organization: "Anthropic",
    name: "Claude 3.5 Sonnet",
    profileImageURL: "/claude.svg",
    type: "balanced",
  },
  {
    id: "claude-3-7-sonnet-latest",
    organization: "Anthropic",
    name: "Claude 3.7 Sonnet",
    profileImageURL: "/claude.svg",
    type: "balanced",
  },
  {
    id: "claude-4-sonnet-20250514",
    organization: "Anthropic",
    name: "Claude 4 Sonnet",
    profileImageURL: "/claude.svg",
    type: "balanced",
  },
  {
    id: "claude-3-5-haiku-latest",
    organization: "Anthropic",
    name: "Claude 3.5 Haiku",
    profileImageURL: "/claude.svg",
    type: "cheap",
  },
  {
    id: "claude-3-opus-latest",
    organization: "Anthropic",
    name: "Claude 3 Opus",
    profileImageURL: "/claude.svg",
    type: "expensive",
  },
  {
    id: "claude-4-opus-20250514",
    organization: "Anthropic",
    name: "Claude 4 Opus",
    profileImageURL: "/claude.svg",
    type: "expensive",
  },
];

export interface Prompt {
  id?: string;
  createdAt?: number;
  userId?: string;
  basePrompt?: string;
  model?: string;
  title?: string;
  style?: string;
  audience?: string;
  tone?: Array<string>;
  persona?: string;
  personaDetails?: string;
  temperature?: number;
  length?: number;
  toExclude?: string;
  toInclude?: string;
  variables: any;
  isEdited: boolean;
  isShared: boolean;
  sharedPromptId?: string;
  parentFolderId?: string | number;
}

export interface Folder {
  id?: string;
  parentFolderId?: string | number;
  createdAt?: number;
  userId?: string;
  name: string;
  isNew?: boolean;
  isEdited?: boolean;
}

export interface PromptState {
  userPrompts: Array<Prompt>;
  userFolders: Array<Folder>;
  isPromptPackagesModalOpen: boolean;
  isLoading: boolean;
  isInitialized: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  isDuplicating: boolean;
  isCopying: boolean;
  isDeletingFolder: boolean;
  isSavingFolder: boolean;
  isMovingFolder: boolean;
  isDownloadingPromptsPackage: boolean;
  isMovingPrompt: boolean;
  isTogglingShare: boolean;
  selectedPrompt: Prompt;
  error?: any;
}

export const defaultLength = 300;
export const defaultTemperature = 70;

const newPrompt = {
  model: "gpt-4o-mini",
  tone: [],
  variables: {},
  style: "",
  persona: "",
  basePrompt: "",
  length: defaultLength,
  temperature: defaultTemperature,
  audience: "",
  toExclude: "",
  toInclude: "",
  isEdited: false,
  isShared: false,
};

const initialState: PromptState = {
  userPrompts: [],
  userFolders: [],
  isPromptPackagesModalOpen: false,
  isLoading: false,
  isInitialized: false,
  isSaving: false,
  isDeleting: false,
  isDuplicating: false,
  isCopying: false,
  isDeletingFolder: false,
  isSavingFolder: false,
  isMovingFolder: false,
  isMovingPrompt: false,
  isDownloadingPromptsPackage: false,
  isTogglingShare: false,
  selectedPrompt: newPrompt,
};

export const initPromptsFromServer = createAsyncThunk(
  "prompts",
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${apiBaseURL}/prompts`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const saveFolder = createAsyncThunk(
  "folders/save",
  async (folder: Folder, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${apiBaseURL}/folders/save`, folder, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const moveFolder = createAsyncThunk(
  "folders/move",
  async (
    moveFolderDetails: {
      sourceFolderId: string | number;
      targetFolderId: string | number;
    },
    thunkAPI
  ) => {
    try {
      const token = localStorage.getItem("token");
      const { sourceFolderId, targetFolderId } = moveFolderDetails;
      const response = await axios.post(
        `${apiBaseURL}/folders/${sourceFolderId}/move/${targetFolderId}`,
        null,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteFolder = createAsyncThunk(
  "folders/delete",
  async (folderId: string | number, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(`${apiBaseURL}/folders/${folderId}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const downloadPromptsPackage = createAsyncThunk(
  "prompts/downloadPromptsPackage",
  async (promptsPackageId: string, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${apiBaseURL}/prompts/packages/${promptsPackageId}`,
        null,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const movePrompt = createAsyncThunk(
  "prompts/move",
  async (
    movePromptDetails: {
      promptId: string | number;
      folderId: string | number;
    },
    thunkAPI
  ) => {
    try {
      const token = localStorage.getItem("token");
      const { promptId, folderId } = movePromptDetails;
      const response = await axios.post(
        `${apiBaseURL}/prompts/${promptId}/move/${folderId}`,
        null,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const savePrompt = createAsyncThunk(
  "prompts/save",
  async (prompt: Prompt, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${apiBaseURL}/prompts/save`, prompt, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const copySharedPrompt = createAsyncThunk(
  "prompts/copyShared",
  async (sharedPromptId: string, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${apiBaseURL}/prompts/shared/${sharedPromptId}/copy`,
        null,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const duplicatePrompt = createAsyncThunk(
  "prompts/duplicate",
  async (prompt: Prompt, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const newPrompt = { ...prompt };
      delete newPrompt.id;
      if (newPrompt.sharedPromptId) delete newPrompt.sharedPromptId;
      newPrompt.isShared = false;
      const response = await axios.post(
        `${apiBaseURL}/prompts/save?duplicatingPromptId=${prompt.id}`,
        newPrompt,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const toggleSharePrompt = createAsyncThunk(
  "prompts/toggleShare",
  async (promptId: string | undefined, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${apiBaseURL}/prompts/${promptId}/share`,
        null,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deletePrompt = createAsyncThunk(
  "prompts/delete",
  async (prompt: Prompt, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `${apiBaseURL}/prompts/${prompt.id}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      if (error.message) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error
        ) {
          return thunkAPI.rejectWithValue(error.response.data.error);
        }
        return thunkAPI.rejectWithValue(error.message);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const promptsSlice = createSlice({
  name: "prompts",
  initialState,
  reducers: {
    clearUserPrompts: (state, action) => {
      state.userPrompts = [];
    },
    openPromptPackagesModal: (state) => {
      state.isPromptPackagesModalOpen = true;
    },
    closePromptPackagesModal: (state) => {
      state.isPromptPackagesModalOpen = false;
    },
    createNewFolder: (state) => {
      state.userFolders = [
        { id: "-1", isNew: true, isEdited: true, name: "" },
        ...state.userFolders.filter(
          (userFolder) => !userFolder.isNew || userFolder.name !== ""
        ),
      ];
    },
    deleteNewFolder: (state, action) => {
      state.userFolders = state.userFolders.filter((userFolder) => {
        return userFolder.id !== action.payload;
      });
    },
    startEditingFolder: (state, action) => {
      state.userFolders = state.userFolders.map((userFolder) => {
        if (userFolder.id === action.payload) userFolder.isEdited = true;
        return userFolder;
      });
    },
    stopEditingFolder: (state, action) => {
      state.userFolders = state.userFolders.map((userFolder) => {
        if (userFolder.id === action.payload && userFolder.isEdited)
          userFolder.isEdited = false;
        return userFolder;
      });
    },
    createNewPrompt: (state) => {
      state.selectedPrompt = { ...newPrompt };
    },
    selectPromptById: (state, action) => {
      const newSelectedPrompt = state.userPrompts.find(
        (userPrompt) => userPrompt.id === action.payload
      );
      if (newSelectedPrompt) state.selectedPrompt = newSelectedPrompt;
    },
    updateSelectedPrompt: (state, action) => {
      state.selectedPrompt = {
        ...state.selectedPrompt,
        ...action.payload,
        isEdited: true,
      };
    },
    deletePrompt: (state, action) => {
      state.userPrompts = state.userPrompts.filter(
        (item) => item.id !== action.payload.id
      );
    },
    editPrompt: (state, action) => {
      state.userPrompts = state.userPrompts.map((item) =>
        item.id === action.payload.id
          ? { ...item, prompts: action.payload.prompts }
          : item
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initPromptsFromServer.pending, (state) => {
        state.isLoading = true;
        state.isPromptPackagesModalOpen = false;
        state.error = undefined;
      })
      .addCase(initPromptsFromServer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isInitialized = true;
        state.isPromptPackagesModalOpen = action.payload.prompts.length === 0;
        state.userPrompts = [...action.payload.prompts];
        state.userFolders = [...action.payload.folders];
      })
      .addCase(initPromptsFromServer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(savePrompt.pending, (state) => {
        state.isSaving = true;
        state.error = undefined;
      })
      .addCase(savePrompt.fulfilled, (state, action) => {
        state.isSaving = false;
        state.selectedPrompt = { ...action.payload, isEdited: false };
        state.userPrompts = [
          { ...action.payload, isEdited: false },
          ...state.userPrompts.filter(
            (currentPrompt) => currentPrompt.id !== action.payload.id
          ),
        ];
        state.error = undefined;
      })
      .addCase(savePrompt.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload;
      })
      .addCase(copySharedPrompt.pending, (state) => {
        state.isPromptPackagesModalOpen = false;
        state.isCopying = true;
        state.error = undefined;
      })
      .addCase(copySharedPrompt.fulfilled, (state, action) => {
        state.isCopying = false;
        state.selectedPrompt = { ...action.payload, isEdited: false };
        state.userPrompts = [
          { ...action.payload, isEdited: false },
          ...state.userPrompts.filter(
            (currentPrompt) => currentPrompt.id !== action.payload.id
          ),
        ];
        state.error = undefined;
      })
      .addCase(copySharedPrompt.rejected, (state, action) => {
        state.isCopying = false;
        state.error = action.payload;
      })
      .addCase(duplicatePrompt.pending, (state) => {
        state.isDuplicating = true;
        state.error = undefined;
      })
      .addCase(duplicatePrompt.fulfilled, (state, action) => {
        state.isDuplicating = false;
        state.selectedPrompt = { ...action.payload, isEdited: false };
        state.userPrompts = [
          { ...action.payload, isEdited: false },
          ...state.userPrompts.filter(
            (currentPrompt) => currentPrompt.id !== action.payload.id
          ),
        ];
        state.error = undefined;
      })
      .addCase(duplicatePrompt.rejected, (state, action) => {
        state.isDuplicating = false;
        state.error = action.payload;
      })
      .addCase(deletePrompt.pending, (state) => {
        state.isDeleting = true;
        state.error = undefined;
      })
      .addCase(deletePrompt.fulfilled, (state, action) => {
        state.isDeleting = false;
        state.selectedPrompt = { ...action.payload, isEdited: false };
        state.userPrompts = [
          ...state.userPrompts.filter(
            (currentPrompt) => currentPrompt.id !== action.payload.id
          ),
        ];
        state.error = undefined;
      })
      .addCase(deletePrompt.rejected, (state, action) => {
        state.isDeleting = false;
        state.error = action.payload;
      })
      .addCase(saveFolder.pending, (state, action) => {
        state.isSavingFolder = true;
        state.userFolders = state.userFolders.map((userFolder) => {
          if (userFolder.isEdited) {
            userFolder.isEdited = false;
            userFolder.name = action.meta.arg.name;
          }

          return userFolder;
        });
        state.error = undefined;
      })
      .addCase(saveFolder.fulfilled, (state, action) => {
        state.isSavingFolder = false;
        state.userFolders = state.userFolders.map((userFolder) => {
          if (userFolder.isNew) {
            userFolder.isNew = false;
            userFolder.id = action.payload.id;
          }

          return userFolder;
        });
      })
      .addCase(saveFolder.rejected, (state, action) => {
        state.userFolders = state.userFolders.filter((userFolder) => {
          return !userFolder.isNew;
        });
        state.isSavingFolder = false;
        state.error = action.payload;
      })
      .addCase(deleteFolder.pending, (state, action) => {
        state.isDeletingFolder = true;
        state.error = undefined;
      })
      .addCase(deleteFolder.fulfilled, (state, action) => {
        state.isDeletingFolder = false;
        const { deletedFoldersIds, deletedPromptsIds } = action.payload;

        state.userFolders = state.userFolders.filter((userFolder) => {
          return !deletedFoldersIds.includes(userFolder.id);
        });

        state.userPrompts = state.userPrompts.filter((userPrompt) => {
          return !deletedPromptsIds.includes(userPrompt.id);
        });
      })
      .addCase(deleteFolder.rejected, (state, action) => {
        state.isDeletingFolder = false;
        state.error = action.payload;
      })
      .addCase(moveFolder.pending, (state, action) => {
        const { sourceFolderId, targetFolderId } = action.meta.arg;

        state.isMovingFolder = true;
        state.userFolders = state.userFolders.map((userFolder) => {
          if (userFolder.id === sourceFolderId) {
            userFolder.parentFolderId = targetFolderId;
          }

          return userFolder;
        });
        state.error = undefined;
      })
      .addCase(moveFolder.fulfilled, (state, action) => {
        state.isMovingFolder = false;
      })
      .addCase(moveFolder.rejected, (state, action) => {
        state.isMovingFolder = false;
        state.error = action.payload;
      })
      .addCase(movePrompt.pending, (state, action) => {
        const { promptId, folderId } = action.meta.arg;

        state.isMovingPrompt = true;
        state.userPrompts = state.userPrompts.map((userPrompt) => {
          if (userPrompt.id === promptId) {
            userPrompt.parentFolderId = folderId;
          }

          return userPrompt;
        });
        state.error = undefined;
      })
      .addCase(movePrompt.fulfilled, (state, action) => {
        state.isMovingPrompt = false;
      })
      .addCase(movePrompt.rejected, (state, action) => {
        state.isMovingPrompt = false;
        state.error = action.payload;
      })
      .addCase(toggleSharePrompt.pending, (state, action) => {
        state.isTogglingShare = true;
        state.error = undefined;
      })
      .addCase(toggleSharePrompt.fulfilled, (state, action) => {
        state.isTogglingShare = false;
        state.selectedPrompt.sharedPromptId = action.payload.sharedPromptId;
        state.selectedPrompt.isShared = !state.selectedPrompt.isShared;
      })
      .addCase(toggleSharePrompt.rejected, (state, action) => {
        state.isTogglingShare = false;
        state.error = action.payload;
      })
      .addCase(downloadPromptsPackage.pending, (state, action) => {
        state.isDownloadingPromptsPackage = true;
        state.error = undefined;
      })
      .addCase(downloadPromptsPackage.fulfilled, (state, action) => {
        state.isDownloadingPromptsPackage = false;
        if (action.payload) {
          state.userPrompts = [...action.payload.prompts, ...state.userPrompts];
          state.userFolders = [...action.payload.folders, ...state.userFolders];
        }
      })
      .addCase(downloadPromptsPackage.rejected, (state, action) => {
        state.isDownloadingPromptsPackage = false;
        state.error = action.payload;
      });
  },
});

export const {
  selectPromptById,
  editPrompt,
  clearUserPrompts,
  updateSelectedPrompt,
  createNewPrompt,
  createNewFolder,
  deleteNewFolder,
  startEditingFolder,
  stopEditingFolder,
  openPromptPackagesModal,
  closePromptPackagesModal,
} = promptsSlice.actions;
export default promptsSlice.reducer;
